export const themes = {
    white: 'border-white',
    black: 'border-secondary',
    kyber: 'border-kyber-500',
};
//# sourceMappingURL=themes.js.map